"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
}
Object.defineProperty(exports, "__esModule", { value: true });
const path_1 = require("path");
const utils_1 = require("./utils");
const COS = require("cos-js-sdk-v5");
const shortid_1 = require("shortid");
const FileShelf_1 = require("./FileShelf");
__exportStar(require("./notify"), exports);
let FileShelf = /** @class */ (() => {
    class FileShelf extends FileShelf_1.default {
        constructor(options) {
            super(options);
        }
        // 上传文件并存件
        setdownFile(options) {
            return this.uploadFile(options).then(upload => this.setdown({
                paths: [upload.Key]
            }));
        }
        // 上传文件到cos
        uploadFile(options) {
            utils_1.assertArgument(options, 'Body');
            const Key = options.Key
                ? options.Key
                : shortid_1.generate() + path_1.extname(options.Body.name);
            const uploadOptions = Object.assign(Object.assign({ Bucket: FileShelf.BUSKET, Region: FileShelf.REGION, onTaskReady: utils_1.noop, onHashProgress: utils_1.noop, onProgress: utils_1.noop }, options), { Key: path_1.join(this.filePrefix, Key) });
            return new Promise((resolve, reject) => {
                this.cosInstance.sliceUploadFile(uploadOptions, (err, data) => {
                    err ? reject(err) : resolve(data);
                });
            });
        }
        buildCos() {
            const { appId, appKey, cosOptions } = this.options;
            return new COS(Object.assign({ getAuthorization: FileShelf.createAuthorization(appId, appKey) }, cosOptions));
        }
    }
    FileShelf.BUSKET = 'mbcbasic-1251316161';
    FileShelf.REGION = 'ap-beijing';
    FileShelf.NAMESPACE = 'fileshelf';
    return FileShelf;
})();
exports.default = FileShelf;
//# sourceMappingURL=browser.js.map